module.exports = __webpack_public_path__ + "static/media/9.a6ca05ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/9.png
// module id = 689
// module chunks = 0